import { render, staticRenderFns } from "./HealthCheckTable.vue?vue&type=template&id=85491b8c&scoped=true"
import script from "./HealthCheckTable.vue?vue&type=script&lang=ts"
export * from "./HealthCheckTable.vue?vue&type=script&lang=ts"
import style0 from "./HealthCheckTable.vue?vue&type=style&index=0&id=85491b8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85491b8c",
  null
  
)

export default component.exports